export default "__VITE_ASSET__89678a6f__"